/** Posts visible height to the window on resize or scroll .
 * Create a hook on EP to use the visible height being returned
 */
export const subscribeToVisibleHeight = () =>
	window.addEventListener('load', getIntersectionHeightHandler);

export const getIntersectionHeightHandler = () => {
	const targetElement = document.getElementById('full-height-container');

	if (!targetElement) {
		return;
	}
	// Create the IntersectionObserver
	// eslint-disable-next-line no-restricted-syntax
	new IntersectionObserver(postOnIntersectionHeightChange, {
		root: null, // Setting it null for now to use the current Viewport. But need to check if this should be set to iframe test Id instead
		threshold: [0, 1], // Trigger for visibility changes
	}).observe(targetElement);
};

export const postOnIntersectionHeightChange = (entries: Array<IntersectionObserverEntry>) => {
	entries.forEach((entry) => {
		const visibleHeight = entry.intersectionRect.height;

		// Post the visible height to the EP
		window.parent.postMessage(
			{ type: 'embeddedConfluenceVisibleHeight', value: visibleHeight },
			'*',
		);
	});
};
